import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import PetfriendlyHead from './PetfriendlyHead'
import PetfriendlyWhere from './PetfriendlyWhere'
import PetfriendlyPoint from './PetfriendlyPoint'

export default function PetFriendly() {
    const imageHead = {
        title: 'Pets Policy At Our Pet Friendly Hotel For A Comfortable Stay',
        image: "../image/petfriendly-banner.webp",
        breadcrumb: [
            {
                name: "Pet Friendly",
            },
        ]
    }

    return (
        <>   
            <ImageHeader imageHead={imageHead} />
            <PetfriendlyHead />
            <PetfriendlyWhere />
            <PetfriendlyPoint />
        </>
    )
}
